module.exports = __webpack_public_path__ + "static/assets/2613177d7216cceb93f2ccb63e6d8770.svg";